import React from 'react';
import { Modal } from 'react-bootstrap';
import { Form, Control, Errors } from 'react-redux-form';
import InputFields from '../InputFields';
import { useDispatch, useSelector } from 'react-redux';
import Logo from '../../global/img/logo_full_white.png';
import { connect } from 'react-redux';
import EmailVerificationModal from '../EmailVerificationModal';

const PopupRegister = ({ showModal, setShowModal, returnUrl }) => {
    console.log(showModal,'showModal...')
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);
    const isEmailVerified = Boolean(user?.emailVerified || Number(user?.email_verified));
    
    const handleSignup = (data) => {
        dispatch({
            type: 'SIGNUP',
            payload: data
        });
    };

    const handleEmailVerificationClose = () => {
        setShowModal(false);
    };
    console.log(user?.login,'user?.login',returnUrl)

    React.useEffect(() => {
        if (showModal && user?.login && isEmailVerified) {
            setShowModal(false);
        }
    }, [isEmailVerified, setShowModal, showModal, user?.login]);
    
    // If user is logged in but not verified, show email verification modal
    if (user?.login && !isEmailVerified) {
        return (
            <EmailVerificationModal 
                show={showModal} 
                onClose={handleEmailVerificationClose}
                userEmail={user?.email}
                returnUrl={returnUrl}
            />  
        );
    }

    if (user?.login && isEmailVerified) {
        return null;
    }
    
    return (
        <>
          <Modal show={showModal} onHide={() => setShowModal(false)} centered size='lg'>
                <Modal.Body>
                    <section className='signupMainSection'>
                        <div className='signupMainDiv'>
                            <div className='text-center'>
                                <img src={Logo} alt='Inside Injuries Logo' className='signupLogo' />
                                <p className='loginFlowText'>
                                    Already have an account?
                                    <a
                                        href={`/login${returnUrl ? `?returnUrl=${encodeURIComponent(returnUrl)}` : ''}`}
                                        className='loginFlowLink ps-2'
                                    >
                                        Login here
                                    </a>
                                </p>
                            </div>
                            <div className='signupFormDiv'>

                                <>
                                    <Form model="userActions.signup" onSubmit={handleSignup}>
                                        {/* <div className="inputCol">
                                            <InputFields model=".first_name" inputType="text" type="text" placeholder="Enter your first name" label="First Name" />
                                        </div> */}
                                        <div className="inputCol">
                                            <InputFields model=".email" inputType="text" type="email" placeholder="Enter your email" label="Email" />
                                        </div>
                                        <div className="inputCol">
                                            <InputFields model=".password" inputType="text" type="password" placeholder="Enter your password" label="Password" />
                                        </div>
                                        <div className="inputCol">
                                            <label className="inputLabel" style={{ display: 'block', marginBottom: 8 }}>Choose your favorite</label>
                                            <div className="radioGroup">
                                                <label style={{ marginRight: 16 }}>
                                                    <Control.radio model=".favorite_sport" value="NFL" validators={{ required: (val) => !!val }} /> NFL
                                                </label>
                                                <label style={{ marginRight: 16 }}>
                                                    <Control.radio model=".favorite_sport" value="NBA" validators={{ required: (val) => !!val }} /> NBA
                                                </label>
                                                <label style={{ marginRight: 16 }}>
                                                    <Control.radio model=".favorite_sport" value="La Liga" validators={{ required: (val) => !!val }} /> La Liga
                                                </label>
                                                <label>
                                                    <Control.radio model=".favorite_sport" value="EPL" validators={{ required: (val) => !!val }} /> EPL
                                                </label>
                                                <label>
                                                    <Control.radio model=".favorite_sport" value="IPL" validators={{ required: (val) => !!val }} /> IPL
                                                </label>
                                            </div>
                                            <Errors
                                                className="formInputError"
                                                model=".favorite_sport"
                                                messages={{ required: 'Required*' }}
                                                show={{ touched: true, focus: false }}
                                            />
                                        </div>
                                        <div className="w-100">
                                            {/* eslint-disable-next-line react/jsx-pascal-case */}
                                            <Control.button model="userActions.signup" className="loginButton" type="submit">
                                                SIGN UP
                                            </Control.button>
                                        </div>
                                    </Form>
                                    <p className='signupHeaderText'>Join for free and get access to all injury data.</p>

                                </>

                            </div>
                        </div>
                    </section>
                </Modal.Body>
            </Modal>
        </>
    );
}   

const mapStateToProps = (state) => {
    return {
        user: state.user,
        purchasePlan: state.purchasePlan
    };
}


export default connect(mapStateToProps)(PopupRegister);


          